import { useEffect, useState } from "react";
import { listPlans } from "@/api/billing";
import { PLANS, normalizePlan } from "@/data/plans";

// The plan catalog, live from the backend.
//
// Every pricing surface reads it through here so they all show the same numbers
// as each other AND as the limits the backend enforces. The static list in
// data/plans.js is only the fallback for a failed call — the landing page must
// still render pricing if the API is briefly unreachable.
// `country` (#105) is optional — a caller that knows the current company's
// stored country (Billing & Plan) passes it to see the actual per-country
// checkout price on the cards; the public landing page and Signup's picker
// omit it and see exactly what they always have.
export function usePlans(country) {
  const [plans, setPlans] = useState(PLANS);
  const [loading, setLoading] = useState(true);
  const [live, setLive] = useState(false);

  useEffect(() => {
    let cancelled = false;
    listPlans(country)
      .then((res) => {
        const list = Array.isArray(res?.plans) ? res.plans : [];
        if (cancelled || !list.length) return;
        setPlans(list.map(normalizePlan));
        setLive(true);
      })
      // Falling back to the bundled catalog is the whole point of this branch;
      // it is not an error worth interrupting a marketing page for.
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [country]);

  return { plans, loading, live };
}
